import { uiText, useUiLanguage } from '@/i18n/interface';

import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { FormData } from '../../utils/formValidation';

interface EmergencyContactStepProps {
  formData: FormData;
  updateFormData: (field: string, value: string) => void;
}

const EmergencyContactStep: React.FC<EmergencyContactStepProps> = ({ formData, updateFormData }) => {
  useUiLanguage();
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">{uiText("Emergency Contact & Medical Information")}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="emergencyContactName">{uiText("Emergency Contact Name *")}</Label>
          <Input
            id="emergencyContactName"
            value={formData.emergencyContactName}
            onChange={(e) => updateFormData('emergencyContactName', e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="emergencyContactPhone">{uiText("Emergency Contact Phone *")}</Label>
          <Input
            id="emergencyContactPhone"
            value={formData.emergencyContactPhone}
            onChange={(e) => updateFormData('emergencyContactPhone', e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="emergencyContactRelationship">{uiText("Relationship *")}</Label>
          <Input
            id="emergencyContactRelationship"
            value={formData.emergencyContactRelationship}
            onChange={(e) => updateFormData('emergencyContactRelationship', e.target.value)}
            placeholder={uiText("e.g., Parent, Spouse, Sibling")}
            required
          />
        </div>
      </div>

      <div className="space-y-4 mt-6">
        <h4 className="font-medium">{uiText("Medical Information")}</h4>
        <div>
          <Label htmlFor="medicalConditions">{uiText("Medical Conditions")}</Label>
          <Textarea
            id="medicalConditions"
            value={formData.medicalConditions}
            onChange={(e) => updateFormData('medicalConditions', e.target.value)}
            placeholder={uiText("List any medical conditions (leave blank if none)")}
          />
        </div>
        <div>
          <Label htmlFor="currentMedications">{uiText("Current Medications")}</Label>
          <Textarea
            id="currentMedications"
            value={formData.currentMedications}
            onChange={(e) => updateFormData('currentMedications', e.target.value)}
            placeholder={uiText("List any current medications (leave blank if none)")}
          />
        </div>
        <div>
          <Label htmlFor="allergies">{uiText("Allergies")}</Label>
          <Textarea
            id="allergies"
            value={formData.allergies}
            onChange={(e) => updateFormData('allergies', e.target.value)}
            placeholder={uiText("List any allergies (leave blank if none)")}
          />
        </div>
        <div>
          <Label htmlFor="injuries">{uiText("Previous Injuries")}</Label>
          <Textarea
            id="injuries"
            value={formData.injuries}
            onChange={(e) => updateFormData('injuries', e.target.value)}
            placeholder={uiText("List any previous injuries that may affect training")}
          />
        </div>
      </div>
    </div>
  );
};

export default EmergencyContactStep;
